<template>
  <div class="gap-4 flex flex-col">
    <SectionsListItem
      v-for="filteredSection of list"
      :key="filteredSection.slug"
      :filtered-section="filteredSection"
    />
  </div>
</template>

<script>
import SectionsListItem from '@/components/Hub/Sections/SectionsListItem.vue'

export default {
  name: 'HubSectionsList',

  components: { SectionsListItem },

  props: {
    list: { type: Array, default: () => [] }
  }
}
</script>
